// extracted by mini-css-extract-plugin
export var closeButton = "_f3-2";
export var closeButtonIcon = "_f3-3";
export var lightboxContent = "_f3-1";
export var lightboxOverlay = "_f3-0";